import clsx from "clsx";
import QuerySearchBar from "ui/common/containers/QuerySearchBar/QuerySearchBar";
import useTranslate from "ui/locale/hooks/useTranslate";

export interface SearchBarFilterProps {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

function SearchBarFilter({ className, ...rest }: SearchBarFilterProps) {
    const translate = useTranslate();
    return <QuerySearchBar placeholder={translate("searchInStore")} className={clsx("search-bar-filter", className)} {...rest} />;
}

export default SearchBarFilter;
